import { type AuthConfig } from '@dss/auth'

/** Конфиг OIDC PKCE для admin app.
 *
 *  `authority` (Keycloak realm URL) и `client_id` — статические, идут из
 *  VITE_KEYCLOAK_* env vars build-time. Дефолты подставлены для local dev.
 *
 *  `redirect_uri` / `post_logout_redirect_uri` — динамические через
 *  `window.location.origin` (admin SPA открывается и на `admin.ds2b.ru`, и на
 *  `<slug>.ds2b.ru`; S21 / D14-Arch-3) с фиксированным префиксом `/admin/`
 *  (Vite `base: '/admin/'`, TanStack Router `basepath: '/admin'`). Хардкод
 *  одного хоста build-time ломает OIDC flow на остальных хостах: KC redirect-ит
 *  на фиксированный URL, попадает в SPA с другой in-memory `oidc-client-ts`
 *  сессией → state не совпадает → callback зависает на «Завершаем вход…».
 */
export const authConfig: AuthConfig = {
  authority:
    import.meta.env.VITE_KEYCLOAK_AUTHORITY ??
    'http://localhost:8080/realms/distribution-software-sales',
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'dss-backend',
  redirect_uri: `${window.location.origin}/admin/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/admin/logout`,
  // После signinCallback() URL очищается до этого значения; admin SPA mount-ed
  // под `/admin/` (Vite base + TanStack basepath), поэтому возвращаем туда.
  postCallbackUrl: '/admin/',
}
